// @flow
import { has } from "../../utils/helpers/objects";

import AttributeCollection from "../attributes/AttributeCollection";

import UserModel from "./UserModel";

import type { ModularUIResponse } from "../../modularui";

/**
 * User model
 */
export default class UserProfileModel extends UserModel {
  _attributeCollection: AttributeCollection;

  /**
   * constructor
   */
  constructor(modularuiResponse: ModularUIResponse) {
    super(modularuiResponse);

    const attributeContributions = this.contributions.attributes
      ? this.contributions.attributes.filter((contribution) => {
          const [key] = Object.keys(contribution);
          return key !== "sessiondata" && has(this.data, key);
        })
      : [];

    this._attributeCollection = new AttributeCollection(
      this.data,
      attributeContributions,
      { ...this.modelOptions, isReadonly: true },
    );
  }

  /**
   */
  get type(): string {
    return "UserProfile";
  }

  /**
   * returns all the attributes from the attribute collection
   */
  get attributeCollection(): AttributeCollection {
    return this._attributeCollection;
  }

  /**
   */
  static get modelName(): string {
    return "UserProfileModel";
  }
}
